import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-10"
}
const _hoisted_2 = { class: "max-w-6xl mx-auto flex items-center justify-center md:justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "hidden md:block text-2xl leading-8 font-bold text-white" }, "Janover shared a deal with You", -1)
const _hoisted_4 = { class: "flex items-center md:justify-between justify-end" }
const _hoisted_5 = { class: "text-base leading-6 font-medium text-white" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-base leading-6 text-indigo-100 text-sm" }, "Advisor @ Janover", -1)
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 1,
  class: "max-w-6xl mx-auto grid grid-cols-8 gap-6"
}
const _hoisted_11 = { class: "col-span-2 hidden lg:block" }
const _hoisted_12 = { class: "lg:sticky lg:self-start top-6 space-y-6" }
const _hoisted_13 = {
  key: 0,
  class: "col-span-9 lg:col-span-6"
}
const _hoisted_14 = { class: "bg-white rounded-lg shadow py-4 md:py-6 overflow-hidden" }
const _hoisted_15 = { class: "px-4 md:px-6 mb-4 md:mb-6 flex justify-between items-center" }
const _hoisted_16 = { class: "text-xl md:text-2xl font-extrabold md:leading-6 text-gray-900" }
const _hoisted_17 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { id: "summary" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "px-4 md:px-6 mt-6 md:mt-8"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", { class: "font-extrabold text-lg md:text-2xl mb-2 md:mb-4 text-sky" }, "Summary", -1)
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 1,
  class: "px-4 md:px-6 mt-6 md:mt-8"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", { class: "font-extrabold text-lg md:text-2xl mb-2 md:mb-4 text-sky" }, "Deal Highlights", -1)
const _hoisted_24 = { class: "flex flex-wrap justify-start" }
const _hoisted_25 = {
  key: 2,
  class: "mt-6 md:mt-8",
  id: "location"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h4", { class: "px-4 md:px-6 font-extrabold text-lg md:text-2xl mb-2 md:mb-4 text-sky" }, "Property Location", -1)
const _hoisted_27 = {
  class: "mt-6 md:mt-8",
  id: "data-points"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h4", { class: "font-extrabold text-lg md:text-2xl mb-2 md:mb-4 text-sky px-4 md:px-6" }, "Data points", -1)
const _hoisted_29 = {
  key: 3,
  class: "mt-6 md:mt-8 px-4 md:px-6",
  id: "documents"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h4", { class: "font-extrabold text-lg md:text-2xl mb-2 md:mb-4 text-sky" }, "Documents attached", -1)
const _hoisted_31 = {
  class: "mt-6 md:mt-8 -mb-4 md:-mb-6",
  id: "soft-quote"
}
const _hoisted_32 = { class: "p-4 md:p-6 bg-gray-100" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl md:text-2xl lg:text-3xl font-extrabold mb-2" }, "Want more information on this deal and to see more like it?", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm md:text-base lg:text-lg max-w-2xl" }, "Click “next” below to login to your account or create a new one if you don’t have it. You’ll be able to see additional details on this loan, download documents, and submit a soft quote, request more info, or turn it down. You’ll also be able to setup your credit box quickly and easily to see more deals like it!", -1)
const _hoisted_35 = { class: "flex items-center justify-start mt-4 md:mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")!
  const _component_MailIcon = _resolveComponent("MailIcon")!
  const _component_om_cta_box = _resolveComponent("om-cta-box")!
  const _component_om_navigation = _resolveComponent("om-navigation")!
  const _component_om_advisor_box = _resolveComponent("om-advisor-box")!
  const _component_om_pictures = _resolveComponent("om-pictures")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_deal_location = _resolveComponent("deal-location")!
  const _component_deal_answers = _resolveComponent("deal-answers")!
  const _component_deal_documents = _resolveComponent("deal-documents")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.om)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "w-20 h-20 rounded-lg bg-gray-100 mr-4 flex justify-center items-center",
                style: _normalizeStyle({ 'background-image': `url(${_ctx.getAdvisorImage(_ctx.om.advisor.email)})`, 'background-size': 'cover' })
              }, [
                false
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("IMG")
                    ], 64))
                  : _createCommentVNode("", true)
              ], 4),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.om.advisor.name), 1),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.om.advisor.phone)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: `tel:${_ctx.om.advisor.phone}`,
                        class: "px-2 py-1 text-xs bg-white border rounded-md inline-flex items-center mt-2 mr-2 opacity-80 pointer-events-none"
                      }, [
                        _createVNode(_component_PhoneIcon, { class: "w-3 h-3 mr-1" }),
                        _createTextVNode(" Call ")
                      ], 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    href: `mailto:${_ctx.om.advisor.email}`,
                    class: "px-2 py-1 text-xs bg-white border rounded-md inline-flex items-center mt-2"
                  }, [
                    _createVNode(_component_MailIcon, { class: "w-3 h-3 mr-1" }),
                    _createTextVNode(" Email ")
                  ], 8, _hoisted_9)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_om_cta_box),
              _createVNode(_component_om_navigation, {
                showQuote: true,
                om: _ctx.om,
                map: false
              }, null, 8, ["om"]),
              _createVNode(_component_om_advisor_box, {
                advisor: _ctx.om.advisor
              }, null, 8, ["advisor"])
            ])
          ]),
          (_ctx.om)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.om.headline), 1),
                      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.om.shortDescription), 1)
                    ])
                  ]),
                  _createVNode(_component_om_pictures, {
                    pictures: _ctx.om.pictures,
                    propertyType: _ctx.type
                  }, null, 8, ["pictures", "propertyType"]),
                  _hoisted_18,
                  (_ctx.om.narrative)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("div", {
                          class: "max-w-3xl text-sm md:text-base narrative-box",
                          innerHTML: _ctx.parseMarkdown(_ctx.om.narrative)
                        }, null, 8, _hoisted_21)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.om.investmentHighlights)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlights, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "w-1/2 mb-2 flex justify-start items-center text-sm md:text-base",
                              key: index
                            }, [
                              _createVNode(_component_CheckIcon, { class: "w-4 h-4 md:w-5 md:h-5 text-green-500 mr-2 flex-shrink-0" }),
                              _createTextVNode(" " + _toDisplayString(item), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.map)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _createVNode(_component_deal_location, { map: _ctx.map }, null, 8, ["map"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_deal_answers, {
                      answers: _ctx.om.dataPoints
                    }, null, 8, ["answers"])
                  ]),
                  (_ctx.om.documents.filter(item => item.isVisible).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _hoisted_30,
                        _createVNode(_component_deal_documents, {
                          documents: _ctx.om.documents
                        }, null, 8, ["documents"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _hoisted_34,
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_router_link, {
                          to: "/",
                          class: "text-xs lg:text-base text-white bg-green-600 hover:bg-green-800 rounded-md mr-2 lg:mr-4 py-2 px-4 focus:outline-none border-none"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Next ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}